export default __webpack_public_path__ + "static/media/banner.ff8cf9dd.svg";